export class RestablecerModel {
  nombreUsuario: string;
  recaptchaToken: string;

  constructor(user) {
    this.nombreUsuario = user.nombreUsuario;
    this.recaptchaToken = user.recaptchaToken;
  }
}



// WEBPACK FOOTER //
// ./src/app/@compartidos/models/restablecer.model.ts